import { ClientTable } from 'vue-tables-2';
import ServerTable from './vuetable2-checkbox/v-server-table';
import Vue from 'vue';
// var ServerTable = require('./vuetable2-checkbox/v-server-table');

let options = {
    useReportFilter: false,
    texts: {
        count:
            'Showing {from} to {to} of {count} records|{count} records|One record',
        limit: 'Records per page :',
        filterPlaceholder: 'Search...',
        loading: 'Loading...',
        filter: '',
        title: null,
        description: null,
    },
    compileTemplates: true,
    highlightMatches: true,
    pagination: {
        dropdown: false,
        chunk: 5,
    },
    checkbox: false,
    checkboxDisableCallback: row => false,
    checkboxClickCallback: row => {},
    filterByColumn: false,
    datepickerOptions: {
        showDropdowns: true,
    },
    actionButtons: [],
    exports: {},
    pdf_url: false,
    csv_url: false,
    xlsx_url: false,
    create_btn: {},
    perPageValues: [5, 10, 20, 40, 80],
    skin: 'table-hover table m-b-0 b-b',
    sortIcon: {
        is: 'sorting',
        up: 'sorting asc',
        down: 'sorting desc',
    },
    permission: {
        create: null,
        update: null,
        delete: null,
    },
    debounce: 500,
};

Vue.use(
    ClientTable,
    options,
    false,
    'bootstrap4',
    require('../plugins/vuetable2-checkbox/template.jsx'),
);

Vue.use(
    ServerTable,
    options,
    true,
    'bootstrap4',
    require('../plugins/vuetable2-checkbox/template.jsx'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2.js